import React from 'react';
import './DocsList.scss';
import './DocsList-media.scss';
import WordpressDoc from "../Doc/WordpressDoc";
import {IWordpressFile} from "../../services/content/interfaces/IWordpressFile";

export interface Props {
  list: IWordpressFile[];
  grid?: number;
}

const WordpressDocsList = ({ list, grid }: Props) => {
  console.log('list', list);
  return (
    <div
      className={`docs-list${grid ? ' docs-list_grid' : ''}`}
      style={grid ? { gridTemplateColumns: `repeat(${grid}, auto)` } : {}}
    >
      {list.map((item, i) => (
        <WordpressDoc {...item} key={i} />
      ))}
    </div>
  );
};

export default WordpressDocsList;
